import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style";
import { IoMdPerson } from "react-icons/io";
import { FaBuilding, FaFileAlt } from "react-icons/fa";
import { RiBillFill } from "react-icons/ri";
import { BsBank2 } from "react-icons/bs";
import { useNotification } from "../../../hooks/useNotification";
import moment from "moment";
import axios from "axios";

const Profile = () => {
  const classes = useStyles();
  const [userDetails, setUserDetails] = useState({});
  const [leavebalanceDetails, setLeaveBalanceDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();

  useEffect(() => {
    fetchProfileData();
  }, []);

  async function fetchProfileData() {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}employee/getUserEmployee`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        // handleNotificationCall("success", response.data.message);

        const data = response.data.data;
        const leave_balance_data = response.data.data?.leave_balance;
        setUserDetails(data);
        setLeaveBalanceDetails(leave_balance_data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.log("Error Fetch Profile Data", error);
    }
  }

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  return (
    <div>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Box display="flex" gap={3} alignItems="center">
              <div className={classes.dot}></div>{" "}
              <div>Casual Leave : {leavebalanceDetails?.casual}</div>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box display="flex" gap={3} alignItems="center">
              <div className={classes.dot}></div>{" "}
              <div>Sick Leave : {leavebalanceDetails?.sick}</div>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box display="flex" gap={3} alignItems="center">
              <div className={classes.dot}></div>{" "}
              <div>Privilege leave : {leavebalanceDetails?.personal}</div>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box display="flex" gap={3} alignItems="center">
              <div className={classes.dot}></div>{" "}
              <div>Permissions : {leavebalanceDetails?.permission}</div>
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="User Details" />
        </Grid>
      </Grid>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          gap: "10px",
        }}
      >
        <div style={{ color: "lightblue" }}>
          <IoMdPerson size={25} />
        </div>
        <p style={{ padding: "0" }}>Personal Details</p>
      </Box>

      <Box pb={4}>
        <Grid container spacing={3}>
          {/* Column 1 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Name
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.firstName
                  : userDetails.recruiter
                  ? userDetails.recruiter.firstName
                  : "-"}{" "}
                {userDetails.employee
                  ? userDetails.employee?.lastName
                  : userDetails.recruiter
                  ? userDetails.recruiter.lastName
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Date of Birth
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? moment(userDetails.employee?.dob).format("DD-MM-YYYY")
                  : userDetails.recruiter
                  ? moment(userDetails.recruiter?.dob).format("DD-MM-YYYY")
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Gender
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.gender
                  : userDetails.recruiter
                  ? userDetails.recruiter.gender
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Blood Group
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.bloodGroup
                  : userDetails.recruiter
                  ? userDetails.recruiter.bloodGroup
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Current Address
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.currentAddress
                  : userDetails.recruiter
                  ? userDetails.recruiter.currentAddress
                  : "-"}
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Date of Joining
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? moment(userDetails.employee?.joinningDate).format(
                      "DD-MM-YYYY",
                    )
                  : userDetails.recruiter
                  ? moment(userDetails.recruiter?.joinningDate).format(
                      "DD-MM-YYYY",
                    )
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Marital Status
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.maritalStatus
                  : userDetails.recruiter
                  ? userDetails.recruiter.maritalStatus
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="body2" color="textSecondary">
                  Spouse Name
                </Typography>
              </Box>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.spouseName
                  : userDetails.recruiter
                  ? userDetails.recruiter.spouseName
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Contact Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.mobile
                  : userDetails.recruiter
                  ? userDetails.recruiter.mobile
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Personal Email
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.personalEmail
                  : userDetails.recruiter
                  ? userDetails.recruiter.personalEmail
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Permanent Address
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.permanentAddress
                  : userDetails.recruiter
                  ? userDetails.recruiter.permanentAddress
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Father Name
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.fatherName
                  : userDetails.recruiter
                  ? userDetails.recruiter.fatherName
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Mother Name
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.motherName
                  : userDetails.recruiter
                  ? userDetails.recruiter.motherName
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Emergency Contact Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.emergencyMobile
                  : userDetails.recruiter
                  ? userDetails.recruiter.emergencyMobile
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Emergency Contact Name & Relationship
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.emergencyContactRelation
                  : userDetails.recruiter
                  ? userDetails.recruiter.emergencyContactRelation
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                {" "}
                Total Experience (in Years)
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.totalExperience
                  : userDetails.recruiter
                  ? userDetails.recruiter.totalExperience
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          gap: "10px",
        }}
      >
        <div style={{ color: "#e90710" }}>
          <FaBuilding size={25} />
        </div>
        <p style={{ padding: "0" }}>Office Details</p>
      </Box>

      <Box pb={4}>
        <Grid container spacing={3}>
          {/* Column 1 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="body2" color="textSecondary">
                  Official Email
                </Typography>
              </Box>
              <Typography variant="subtitle1">{userDetails.email}</Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Company Branch Name & Address
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.employee
                  ? userDetails.employee?.companyBranchName
                  : userDetails.recruiter
                  ? userDetails.recruiter.companyBranchName
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Designation
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.designation ? userDetails.designation : "-"}
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Department
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.department ? userDetails.department : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Direct Reporting To
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.direct_reportingto
                  ? getEmpName(userDetails.direct_reportingto)
                  : "-"}
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                {" "}
                Dotted Reporting To
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.dot_reportingto
                  ? getEmpName(userDetails.dot_reportingto)
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {userDetails?.employee_contracts &&
        userDetails?.employee_contracts.length > 0 && (
          <>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "20px",
                gap: "10px",
              }}
            >
              <div style={{ color: "#8333c3" }}>
                <FaFileAlt size={25} />
              </div>
              <p style={{ padding: "0" }}>Contract Details</p>
            </Box>
            <Box>
              <p style={{ margin: "10px 0px", fontSize: "16px" }}>
                Client Name
              </p>
              <p style={{ padding: "0" }}>
                {userDetails.salary_detail?.contractClientName
                  ? userDetails.salary_detail?.contractClientName
                  : "-"}
              </p>
            </Box>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "20px",
                gap: "10px",
              }}
            >
              <Grid container direction="row">
                <Grid item xs={12} lg={6}>
                  <TableContainer
                    component={Paper}
                    style={{ width: "100%", margin: "12px 0px" }}
                  >
                    <Table
                      // className={classes.table}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Type</TableCell>
                          <TableCell align="left">Details</TableCell>
                          <TableCell align="right">From Date</TableCell>
                          <TableCell align="right">To Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {userDetails.employee_contracts.map((row) => (
                          <TableRow
                            style={{ background: "#fff" }}
                            key={row.contractStartDate}
                          >
                            <TableCell align="left">
                              {row.contractType}
                            </TableCell>
                            <TableCell align="left">
                              {row.contractDetails}
                            </TableCell>
                            <TableCell align="right">
                              {moment(row.contractStartDate).format(
                                "DD MMMM YYYY",
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {moment(row.contractEndDate).format(
                                "DD MMMM YYYY",
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          gap: "10px",
        }}
      >
        <div style={{ color: "#d1c42a" }}>
          <BsBank2 size={25} />
        </div>
        <p style={{ padding: "0" }}>KYC Details</p>
      </Box>

      <Box pb={4}>
        <Grid container spacing={3}>
          {/* Column 1 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Aadhaar Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.aadhaarNumber}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                PAN Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.panNumber}
              </Typography>
            </Box>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                UAN Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.uanNumber
                  ? userDetails.salary_detail?.uanNumber
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                PF Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.pfNumber}
              </Typography>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Bank Name
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.bankName
                  ? userDetails.salary_detail?.bankName
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Bank Account Number
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.bankAccountNumber
                  ? userDetails.salary_detail?.bankAccountNumber
                  : "-"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Bank IFSC Code
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.bankIfscCode
                  ? userDetails.salary_detail?.bankIfscCode
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          gap: "10px",
        }}
      >
        <div style={{ color: "#c77ac3" }}>
          <RiBillFill size={25} />
        </div>
        <p style={{ padding: "0" }}>Payslip Details</p>
      </Box>

      <Box pb={4}>
        <Grid container spacing={3}>
          {/* Column 1 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                {" "}
                Basic Salary
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.basicSalary
                  ? userDetails.salary_detail?.basicSalary
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Special Allowance
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.specialAllowance
                  ? userDetails.salary_detail?.specialAllowance
                  : "-"}
              </Typography>
            </Box>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={4}>
            <Box mb={2}>
              <Typography variant="body2" color="textSecondary">
                Shift Allowance
              </Typography>
              <Typography variant="subtitle1">
                {userDetails.salary_detail?.shiftAllowance
                  ? userDetails.salary_detail?.shiftAllowance
                  : "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Profile;
